
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'TelefoneEmail'
})
export class TelefoneEmailPipe implements PipeTransform {
  email = false;
  guardInput = '';
  inputString = '';
  ultimaLetra = false;

  transform(input: any): any {
    if (input) {
      this.inputString = input.toString();
      if (this.inputString.length  ===  1) {
        this.email = false;
        this.guardInput = '';

      }

      const isnum = /^\d+$/.test(input[this.inputString.length - 1]);
      if (input[this.inputString.length - 1]  ===  '@' || !isnum) {
        this.email = true;
      }
    }

    if (this.inputString.length >= 11 && !this.email) {
      if (this.inputString.length > 14) {

        let inputLocal = this.inputString.substr(1, this.inputString.length - 1);
        for (let i = 0; i < 3; i++) {
          inputLocal = inputLocal.replace(')', '');
          inputLocal = inputLocal.replace('-', '');
          inputLocal = inputLocal.replace(' ', '');
        }
        return inputLocal;
      } else {
        this.ultimaLetra = true;
        this.guardInput = '(' +
          this.inputString.substring(0, 2).concat(')')
            .concat(' ')
            .concat(this.inputString.substring(2, 3))
            .concat(' ')
            .concat(this.inputString.substring(3, 7))
            .concat(' ')
            .concat(this.inputString.substring(7, 12));
        return this.guardInput;

      }
    }

    // CASO VENHA DO BANCO, QUE POR PADRÃO É NUMBER
    if (typeof input  ===  'number') {

      if (this.inputString.length  ===  8) {
        return `${this.inputString.slice(0, 4)} ${this.inputString.slice(4, 8)}`;
      }

      if (this.inputString.length  ===  9) {
        return `${this.inputString.slice(0, 1)} ${this.inputString.slice(1, 5)} ${this.inputString.slice(5, 9)}`;
      }

      if (this.inputString.length  ===  11) {
        // tslint:disable-next-line:max-line-length

        return `(${this.inputString.slice(0, 2)}) ${this.inputString.slice(2, 3)} ${this.inputString.slice(3, 7)} ${this.inputString.slice(7, 11)}`;
      }

      return input;
    }
    if (this.ultimaLetra) {
      this.ultimaLetra = false;
      return input[input.length - 1];
    }

    return input;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/telefone-email.pipe.ts